import { render } from "./TagList.vue?vue&type=template&id=572c7670&scoped=true&ts=true"
import script from "./TagList.vue?vue&type=script&lang=ts"
export * from "./TagList.vue?vue&type=script&lang=ts"

import "./TagList.vue?vue&type=style&index=0&id=572c7670&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572c7670"]])

export default __exports__